<style scoped lang="less">
.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #fff;
	margin-bottom: 20px;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	button:last-child {
		background-color: #ff8300;
	}

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;
	.sclectlable {
		margin-right: 20px;
	}
}

.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}
.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		text-align: center;
	}

	/deep/ td {
		text-align: center;
	}

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 60px;
		// padding: 2px 0;
		font-size: 12px;
		background-color: #f41127;
	}
}
</style>
<template>
	<div>
		<titles titlename="学习地图分配管理" titlecontent="这里可以学习地图分配" :mbx="paths"></titles>
		
		<!-- <div class="manageselect">
			<div class="sclectlable">
				<div><el-input placeholder="请输入用户名" v-model="input" clearable></el-input></div>
			</div>
		
			<div class="sclectlable">
				<div><el-input placeholder="请输入真实姓名" v-model="input" clearable></el-input></div>
			</div>
			<div class="primarybtn"><el-button type="primary" icon="el-icon-search">搜索</el-button></div>
		</div> -->
		
		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column label="地图名称" prop="zyname"></el-table-column>
							<el-table-column label="创建者" prop="zyname"></el-table-column>
							<el-table-column label="创建时间" prop="zyname"></el-table-column>
							<el-table-column label="状态" prop="zyname"></el-table-column>
							<el-table-column label="操作" fixed="right">
								<template slot-scope="scope">
									<el-button size="mini" style="background-color: #F39C12;">审核</el-button>
									<el-button size="mini" style="background-color: #F39C12;">添加</el-button>
									<el-button size="mini" style="background-color: #E74C3C;">驳回</el-button>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ tabsnun }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="tabsnum"
							:total="totalall"
							:current-page="tabindex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"
	
	export default{
		data(){
			return{
				// 标题
				paths: [{
					path: "/homesview/learningmap/allocation",
					name: "学习地图分配管理"
				}],
				tabsnum: 10,
				totalall: 10,
				tabindex: 1,
				// 专业筛选项列表
				options: [
					{
						value: '选项1',
						label: '黄金糕'
					},
					{
						value: '选项2',
						label: '双皮奶'
					},
					{
						value: '选项3',
						label: '蚵仔煎'
					},
					{
						value: '选项4',
						label: '龙须面'
					},
					{
						value: '选项5',
						label: '北京烤鸭'
					}
				],
				value: '',
				input: '',
				pagesobj: {
					pageSize: 10,
					pageIndex: 1
				},
				tabsnun: 1,
				tableData: [
					{
						zyname: '资源测试020202',
						zyproname: '城市轨道交通运营管理',
						gweiname: '行车值班员',
						zytype: '文本',
						uploadname: 'A超级管理员',
						uploadtimet: '2023-07-01 10:50:36',
						qxname: '公开',
						shstatus: '审核中',
						carriage: '上架'
					},
					{
						zyname: '资源测试020202',
						zyproname: '城市轨道交通运营管理',
						gweiname: '行车值班员',
						zytype: '文本',
						uploadname: 'A超级管理员',
						uploadtimet: '2023-07-01 10:50:36',
						qxname: '公开',
						shstatus: '审核中',
						carriage: '上架'
					},
					{
						zyname: '资源测试020202',
						zyproname: '城市轨道交通运营管理',
						gweiname: '行车值班员',
						zytype: '文本',
						uploadname: 'A超级管理员',
						uploadtimet: '2023-07-01 10:50:36',
						qxname: '公开',
						shstatus: '审核中',
						carriage: '上架'
					},
					{
						zyname: '资源测试020202',
						zyproname: '城市轨道交通运营管理',
						gweiname: '行车值班员',
						zytype: '文本',
						uploadname: 'A超级管理员',
						uploadtimet: '2023-07-01 10:50:36',
						qxname: '公开',
						shstatus: '审核中',
						carriage: '上架'
					}
				]
			}
		},
		components: {
			titles
		},
		methods: {
			indexMethod(index) {
				return index + 1;
			},
			changecurr(val) {
				
			}
		}
		
	}
	
	
</script>

